module.exports = __webpack_public_path__ + "r-v3/img/sticker_24_icon.790d909f.svg";